import { sessionStore } from "@/Globals/Stores/SessionStore";
import { BaseWorkflowStep } from "../../BaseWorkflow/Steps/BaseWorkflowStep";
import { LoginWorkflowStepEnum } from "../LoginWorkflowStepEnum";

class AcceptAgreementStep extends BaseWorkflowStep<LoginWorkflowStepEnum> {
    public constructor() {
        super(LoginWorkflowStepEnum.AcceptAgreement);
    }

    public isValid(): boolean {
        return !sessionStore.acceptedAgreement; // This step will occur only if the user has not accepted the agreement
    }

    public isCompleted(): boolean {
        return sessionStore.acceptedAgreement;
    }
}

export { AcceptAgreementStep };
